export default "__VITE_ASSET__n$Gr44Km__"